import { SVGProps, Ref, forwardRef } from 'react';

export const ClockRewindOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M14.6 8c0 1.409-.353 2.742-1.161 3.711-.79.947-2.088 1.639-4.189 1.639-.83 0-1.535-.108-2.133-.297l-1.085 1.085c.891.393 1.96.612 3.218.612 2.437 0 4.163-.82 5.264-2.142C15.597 11.308 16 9.616 16 8c0-1.617-.403-3.308-1.486-4.607C13.413 2.07 11.687 1.25 9.25 1.25s-4.163.82-5.264 2.143C2.903 4.692 2.5 6.383 2.5 8v2.31L.995 8.805l-.99.99L3.2 12.99l3.194-3.195-.99-.99L3.9 10.31V8c0-1.408.354-2.742 1.161-3.711.79-.947 2.089-1.639 4.189-1.639s3.4.692 4.189 1.639C14.247 5.258 14.6 6.592 14.6 8"
                    fill="currentColor"
                />
                <path d="M8.55 4v4.391l3.583 2.205.734-1.192L9.95 7.609V4z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
ClockRewindOutlinedSize16Glyph.displayName = 'ClockRewindOutlinedSize16Glyph';
